import { render, staticRenderFns } from "./moduleCard.vue?vue&type=template&id=de071bda&"
import script from "./moduleCard.vue?vue&type=script&lang=js&"
export * from "./moduleCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports